import { z } from 'zod';

const VISITOR_TOKEN_SCHEMA = z.object({
  visitorKey: z.string(),
});

export function parseVisitorKey(visitorToken: string): string | null {
  try {
    const decoded = unsafeDecodeVisitorToken(visitorToken);
    const result = VISITOR_TOKEN_SCHEMA.safeParse(decoded);

    if (result.success) {
      return result.data.visitorKey;
    }

    return null;
  } catch (e) {
    return null;
  }
}

function unsafeDecodeVisitorToken(visitorToken: string): string | null {
  try {
    return JSON.parse(
      Buffer.from(visitorToken.split('.')[1]!, 'base64').toString(),
    );
  } catch (e) {
    return null;
  }
}
